module.exports = __webpack_public_path__ + "static/media/descuentos.a9c07c3d.svg";